import { memo as Memo, useEffect, useRef, useMemo, useState } from 'react';

//* Components
import CustomCollapse from '@/components/global/CustomCollapse';

const CustomSelect = Memo((props) => {
	//! States
	const [isOpened, setIsOpened] = useState(false);
	const selectValRef = useRef();
	const selectListRef = useRef();

	//! Toggle Select
	const toggleSelectBox = () => {
		setIsOpened(!isOpened);
	};

	//! Handle Click
	const handleClick = (e) => {
		if (!selectValRef.current.contains(e.target) && !selectListRef.current.contains(e.target) && isOpened) {
			toggleSelectBox();
		}
	};

	//! Click Event Listener
	useEffect(() => {
		document.addEventListener('mousedown', handleClick);

		return () => {
			document.removeEventListener('mousedown', handleClick);
		};
	});

	//! Element Select
	const elClick = (selectedEl) => {
		isOpened && toggleSelectBox();
		props.onChange && props.onChange(selectedEl);
	};

	//! Selected Value HTML
	const selectedValueHTML = useMemo(() => {
		return (
			<div
				ref={selectValRef}
				onClick={toggleSelectBox}
				className={`selected-val ${props.placeholder && !props.selected.label ? 'placeholder' : ''}`}>
				{props.leftIcon && (typeof props.leftIcon === 'string' ? <i className={`select-left-icon ${props.leftIcon}`} /> : <i className={`select-left-icon`}>{props.leftIcon}</i>)}

				{props.selected.label || (props.placeholder && props.placeholder + (props.required ? '*' : '')) || ''}

				<i className={`select-icon ${props.icon || 'ma-arrow-down'}`} />
			</div>
		);
	}, [props.selected.label, props.placeholder, isOpened]);

	//! List HTML
	const listHTML = useMemo(() => {
		return (
			<div className='list-items'>
				<div
					ref={selectListRef}
					className='select-list'>
					<CustomCollapse isCollapsed={isOpened}>
						{props.list.map((i, k) => (
							<span
								key={k}
								onClick={() => elClick(i)}
								className={`select-list-item ${i.label === props.selected.label ? 'active' : ''}`}>
								{i.label}
							</span>
						))}
					</CustomCollapse>
				</div>
			</div>
		);
	}, [isOpened]);

	return (
		<div className={`select-cont custom-select-cont ${props.errorMsg ? 'error' : ''} ${isOpened ? 'selectbox-opened' : ''} ${props.leftIcon ? 'with-left-icon' : ''}`}>
			{selectedValueHTML}

			{listHTML}
		</div>
	);
});

export default CustomSelect;
